import { FC } from "react";

import { HEADER_LABEL_CLASS, getPageGridClass } from "./grid";

import { SectionKind } from "components/server-types";
import { t } from "i18n/i18n";
import { isTemplateSection } from "utils/publishing";

export const PageGridHeaderRow: FC<{ sectionKind?: SectionKind }> = ({ sectionKind }) => {
  const isInTemplateSection = isTemplateSection(sectionKind);

  return (
    <div
      className={`${getPageGridClass(isInTemplateSection)} border-b border-t border-b-black-tint-70 border-t-black-tint-90 py-1.5`}
      role="row"
    >
      <div className={HEADER_LABEL_CLASS}>{t("manage_section_pages_modal.headers.page_title")}</div>
      <div className={HEADER_LABEL_CLASS}>{t("manage_section_pages_modal.headers.page_type")}</div>
      <div className={HEADER_LABEL_CLASS}>{t("glossary.points")}</div>
      {!isInTemplateSection && (
        <>
          <div className={HEADER_LABEL_CLASS}>
            {t("manage_section_pages_modal.headers.due_date")}
          </div>
          <div className={HEADER_LABEL_CLASS}>{t("manage_section_pages_modal.headers.locked")}</div>
          <div className={HEADER_LABEL_CLASS}>
            {t("manage_section_pages_modal.headers.released")}
          </div>
        </>
      )}
    </div>
  );
};
